import React, { useEffect, useState } from "react"
import { useConsent } from "./consentprovider"
import { generateDefaultConsent, getTCFPurposes } from "../../../lib/consentHelper";
import * as styles from "./style.module.css"
import CloseIcon from "../../images/icons/close.png";

import iabtcflabel from "./iabtcflabel.json"
import config from "../../../config/consent-config";
import ToggleSwitch from "../ToggleSwitch"

const CONSENTPURPOSELIST = getTCFPurposes().consent;

const ConsentBanner = ({ forceShow }) => {
	const { consent, clientRegion, saveConsent, closeConsentBanner } = useConsent()

	const [local, setLocal] = useState(null)
	const [showCustomize, setShowCustomize] = useState(forceShow === true)
	const [showAdvanced, setShowAdvanced] = useState(false)

	useEffect(() => {
		//let initialConsent = consent ? consent : generateDefaultConsent(undefined, clientRegion);
		let initialConsent = consent ? consent : generateDefaultConsent(false);

		setLocal(initialConsent)
	}, [consent, clientRegion])

	/* -----------------------------
		TCF Driven Sync Logic
	----------------------------- */

	function getVendorTCFPurposelist(vendorid, vendorlist) {
		let tmpidx = 0;
		while (tmpidx < vendorlist.length) {
			if (vendorlist[tmpidx].vendorid+""===""+vendorid) {
				return vendorlist[tmpidx].purposeidlist;
			}
			tmpidx++;
		}
		return [];
	}

	function updateVendorAllowed(vendorAttribute, vendorlist, updatedpurpose) {
		let purposeidlist = [];
		for (const vendorId of Object.keys(vendorAttribute)) {
			purposeidlist = getVendorTCFPurposelist(vendorId, vendorlist);
			if (purposeidlist.length > 0) {
				vendorAttribute[vendorId] = purposeidlist.every(pid => updatedpurpose[pid] === true)
			} else {
				vendorAttribute[vendorId] = false;
			}
		}
		return vendorAttribute;
	}

	function setTCFPurposes(map) {
		const newpurpose = {
			...(local.tcf?.purposes || {}),
			...map,
		};

		setLocal(prev => {
			const next = { ...prev };

			// Update TCF purposes ---
			next.tcf = {
				...prev.tcf,
				purposes: newpurpose
			};

			if ("3" in map || "4" in map) {
				// Changed Purpose 3 → Personalized Ads and/or Purpose 4 → Targeted Ads
				const p3 = newpurpose["3"] === true;
				const p4 = newpurpose["4"] === true;

				next.sharing_opt_out = !p4; // reverse of p4/targeted_advertising
				next.targeted_advertising = p4 ? "granted" : "denied";
				next.ad_personalization = p3 ? "granted" : "denied";

				if (!p3 || !p4) {
					next.ad_user_data = "denied"; // disabled, set to denied
					// CCPA sale/share
					// If BOTH P3 and P4 are OFF →  sale_opt_out=true
					if (!p3 && !p4) {
						next.sale_opt_out = true;
						next.profiling = "denied"; // disabled, set to denied
					}
				}

			} // p3 and/or p4



			// Recompute vendor allow/deny ---
			next.tcf.vendors = updateVendorAllowed({ ...prev.tcf.vendors }, config.tcfvendorlist, newpurpose);
			next.nontcf.vendors = updateVendorAllowed({ ...prev.nontcf.vendors }, config.tcfnonvendorlist, newpurpose);

			return next;
		});
	}

	/* -----------------------------
		TCF toggles
	----------------------------- */

	function setVendor(tcfvendor, id, value) {

		const purposeidlist = getVendorTCFPurposelist(
			id,
			tcfvendor ? config.tcfvendorlist : config.tcfnonvendorlist
		);

		if (value) {
			// Verify if vendor allowed to be checked
			const curpurpose = local.tcf?.purposes || {};
			if (!purposeidlist.every(pid => curpurpose[pid] === true)) {
				// Do nothing if not allowed
				return;
			}
		}

		if (tcfvendor) {
			setLocal((prev) => ({
				...prev,
				tcf: {
					...prev.tcf,
					vendors: {
						...(prev.tcf?.vendors || {}),
						[id]: value,
					},
				},
			}))
		} else {
			setLocal((prev) => ({
				...prev,
				nontcf: {
					...prev.nontcf,
					vendors: {
						...(prev.nontcf?.vendors || {}),
						[id]: value,
					},
				},
			}))
		}
		/*
		// Disabled since it's less safe
		if (value) {
			// Enable corresponding cookies required by vendor
			setTCFPurposes(purposeidlist.reduce((out, item) => {
								out[item] = true;
								return out;
							}, {}));
		}
		*/

	}
/*
	// Unused
	function setSpecialFeature(id, value) {
		setLocal((prev) => ({
			...prev,
			tcf: {
				...prev.tcf,
				specialFeatures: {
					...(prev.tcf?.specialFeatures || {}),
					[id]: value,
				},
			},
		}))
	}
*/
	/* -----------------------------
		Consent Management Platform (or Provider) CMP Driven Sync Logic
	----------------------------- */


	/*
	 * FUNCTIONAL / PREFERENCES
	 */

	function onToggleFunctionalGroup(checked) {
		setLocal((prev) => ({
			...prev,
			functionality_storage: checked ? "granted" : "denied",
			personalization_storage: checked ? "granted" : "denied",
			profiling: checked ? "granted" : "denied",
		}))

		setTCFPurposes({ 1: checked, })
	}

	function onToggleFunctionality(checked) {
		setLocal((prev) => ({
			...prev,
			functionality_storage: checked ? "granted" : "denied",
		}))
	}

	function onToggleContentPersonalization(checked) {
		setLocal((prev) => ({
			...prev,
			personalization_storage: checked ? "granted" : "denied",
			profiling:checked ? prev.profiling : "denied" // disabled, set to denied
		}))
	}

	function onToggleProfiling(checked) {
		setLocal((prev) => ({
			...prev,
			profiling: checked ? "granted" : "denied",
		}))
	}

	/*
	 * ANALYTICS
	 */

	function onToggleAnalyticsGroup(checked) {
		setLocal((prev) => ({
			...prev,
			analytics_storage: checked ? "granted" : "denied",
		}))
	}

	function onToggleAnalytics(checked) {
		setLocal((prev) => ({
			...prev,
			analytics_storage: checked ? "granted" : "denied",
		}))
	}

	function onToggleSensitiveDataLimit(checked) {
		setLocal((prev) => ({
			...prev,
			sensitive_data_limit: checked
		}))
	}

	/*
	 * MARKETING AND ADVERTISING
	 */

	function onToggleAdvertisingGroup(checked) {
		setLocal((prev) => ({
			...prev,
			ad_storage: checked ? "granted" : "denied",
			ad_user_data: checked ? "granted" : "denied",
			sale_opt_out: !checked
		}))

		setTCFPurposes({
			1: checked,
			3: checked,
			4: checked,
			7: checked
		})
	}

	function onToggleAds(checked) {
		setLocal((prev) => ({
			...prev,
			ad_storage: checked ? "granted" : "denied",
		}))
	}

	function onTogglePersonalizedAds(checked) {
		// Auto untick since sale_opt_out not displayed and checkbox not disabled
		setLocal(prev => ({
			...prev,
			sale_opt_out: checked ? false : prev.sale_opt_out,
		}))
		// ad_personalization Mirror of TCF P3 - Handle in TCF
		setTCFPurposes({
			3: checked,
		})
	}

	function onToggleTargetedAds(checked) {
		// Auto untick since sale_opt_out not displayed and checkbox not disabled
		setLocal(prev => ({
			...prev,
			sale_opt_out: checked ? false : prev.sale_opt_out,
		}))

		// targeted_advertising Mirror of TCF P4 - Handle in TCF
		setTCFPurposes({
			4: checked,
		})
	}

	function onToggleSaleOptOut(checked) {
		setLocal((prev) => ({
			...prev,
			sale_opt_out: checked,
			// disabled, set to denied
			ad_personalization: checked ? "denied" : prev.ad_personalization,
			targeted_advertising: checked ? "denied" : prev.targeted_advertising,
			ad_user_data: checked ? "denied": prev.ad_user_data,
			profiling: checked ? "denied": prev.profiling,
		}))
		if (checked) {
			// disabled, set to denied
			setTCFPurposes({
				3: false,
				4: false,
			})
		}
	}

	function onToggleAdUserData(checked) {
		setLocal((prev) => ({
			...prev,
			sale_opt_out: checked
				? false
				: local.tcf?.purposes?.[3] === true || local.tcf?.purposes?.[4] === true
					? prev.sale_opt_out
					: true,
			ad_user_data: checked ? "granted" : "denied",
		}));
	}

	function onAdvancedPurposeChange(id, checked) {
		if (id === 3 || id === 4) {
			if (checked) {
				// Only EU will trigger this, sale_opt_out is hidden, but needs to be set to correct value
				setLocal((prev) => ({
					...prev,
					sale_opt_out: false
				}));
			}
		}
		setTCFPurposes({ [id]: checked })
	}


	function onAcceptAll() {
		const defaultConsent = generateDefaultConsent(true);

		let newConsent = { ...defaultConsent };

		newConsent = {
			...newConsent,
			sensitive_data_limit: ["TCF"].includes(clientRegion.type),
			ads_data_redaction: false,
		}
		saveConsent(newConsent);
	}

	function onRejectAll() {
		const defaultConsent = generateDefaultConsent(false);

		let newConsent = { ...defaultConsent };

		newConsent = {
			...newConsent,
			ads_data_redaction: ["TCF", "CPRA"].includes(clientRegion.type)
		}

		saveConsent(newConsent);
	}

	function onSave() {
		let newConsent = { ...local }

		newConsent = {
			...newConsent,
			sensitive_data_limit: ["TCF"].includes(clientRegion.type)?true:newConsent.sensitive_data_limit,
			ads_data_redaction: ["TCF", "CPRA"].includes(clientRegion.type) && newConsent.ad_storage !== "granted"
		}
		saveConsent(newConsent)
	}

	function displayVendor(vendorobj, tcfvendor) {
		return <div key={vendorobj.vendorid}>
			<ToggleSwitch
				checked={tcfvendor ? local.tcf?.vendors?.[vendorobj.vendorid] === true : local.nontcf?.vendors?.[vendorobj.vendorid] === true}
				onChange={e => setVendor(tcfvendor, vendorobj.vendorid, e.target.checked)}
				label={`${tcfvendor ? vendorobj.name + " [TCF Vendor ID " + vendorobj.vendorid + "]" : vendorobj.name}`}
			/>
			<div style={{ marginLeft: "2em" }}>

				{vendorobj.purposeidlist.map(pid => (
					CONSENTPURPOSELIST.includes(pid)
						? <ToggleSwitch
							key={vendorobj.vendorid + pid}
							checked={local.tcf?.purposes[pid]}
							disabled={true}
							label={`${iabtcflabel.purposes["" + pid]} [TCF Purpose ${pid}]`}
						/>
						: <ToggleSwitch
							key={vendorobj.vendorid + pid}
							disabled={true}
							label={`${iabtcflabel.purposes["" + pid]} [TCF Purpose ${pid}]`}
							hidden={true}
						/>
				))}
			</div>
			<br />
		</div>
	}

	function displayTCFPurpose(pid, disabled, additionallabel = "") {
		const checked = local.tcf?.purposes?.[pid] === true;
		if (!CONSENTPURPOSELIST.includes(pid)) {
			return <></>
		}
		return <ToggleSwitch
			disabled={disabled}
			checked={checked}
			onChange={e => onAdvancedPurposeChange(pid, e.target.checked)}
			label={`
				${additionallabel.length > 0 ? additionallabel + " / " : ""}
				${iabtcflabel.purposes[`${pid}`]} [TCF Purpose ${pid}]
			`}
		/>
	}

	const handleClose = () => {
		if (forceShow) {
			// Cookie Settings
			closeConsentBanner();
		} else {
			// Default, initial
			setShowCustomize(false);
		}
	}

	function onKeyDownAccessibility(e, callback) {
		if (e.key === "Enter" || e.key === ' ') {
			e.preventDefault();
			callback();
		}
	}

	if (!local) return null

	// Cannot show TCF official elements if not verified provider
	const isValidTCF = config.IABCMPID > 0 &&  clientRegion.type === "TCF";

	return (<>
	{showCustomize && <div className={styles.consentBannerOverlay} />}
	<div
		className={`${styles.banner} ${!showCustomize ? styles.minimal : ''}`}
		name="consentBanner"
		role="dialog"
		aria-modal="true"
		aria-labelledby="consent-banner-title"
		aria-describedby="consent-banner-desc"
		tabIndex={0}
	>
		{showCustomize &&
			<div className={styles.header}>
				<h2 id="consent-banner-title">Customize Cookie Settings</h2>
				<img
					src={CloseIcon}
					alt="close consent banner"
					className={styles.close}
					name="closeConsentButton"
					onClick={handleClose}
					onKeyDown={(e) => onKeyDownAccessibility(e, handleClose)}
					role="button"
					tabIndex={0}
				/>
			</div>
		}

		<div className={styles.content}>
			{!showCustomize
				? <>
					<div>
						<h2 id="consent-banner-title">We value your privacy</h2>
						<p id="consent-banner-desc">
							We use cookies and similar technologies to analyze traffic,
							personalize content, and measure ads. You can accept, reject, or customize your choices.
						</p>
					</div>
				</>
				: <>
					<p id="consent-banner-desc">
						Choose how we use cookies and similar technologies.
						You can change your choices at any time.
					</p>

					{/* Required */}
					<div className={styles.consentGroup}>
						<div className={styles.groupHeader}>
							<h3>Essential / Necessary</h3>
							{clientRegion.type === "" && <>
								<ToggleSwitch checked={true} disabled={true} label="Always Allowed" labelPosition="left" />
							</>}
						</div>
						<div className={styles.groupContent}>
							<p>
								These are necessary for security, fraud prevention, and delivering site content correctly.
							</p>
							<ul>
								<li>Security & fraud prevention</li>
								<li>Delivering content & ensuring the site works</li>
							</ul>

							{clientRegion.type !== "" && <>
								<ToggleSwitch checked={true} disabled={true} label="Always Allowed" />
							</>}
						</div>
					</div>

					{/* Functionality */}
					<div className={styles.consentGroup}>
						<div className={styles.groupHeader}>
							<h3>Functional / Preferences</h3>
							{clientRegion.type === "" && <>
								<ToggleSwitch
									checked={local.functionality_storage === "granted"}
									onChange={e => onToggleFunctionalGroup(e.target.checked)}
								/>
							</>}
						</div>

						<div className={styles.groupContent}>
							<p>
								These are used to implement additional functionalities or to enhance
								features and website performance.  These include remembering choices
								and generating personalized content, and creating a profile about your
								interests or behavior. This does not include advertising profiles.
							</p>

							{clientRegion.type !== "" && <>
								<ToggleSwitch
									checked={local.functionality_storage === "granted"}
									onChange={e => onToggleFunctionality(e.target.checked)}
									label="Allow functional cookies for non-essential features such as previous choices"
								/>
								<ToggleSwitch
									checked={local.personalization_storage === "granted"}
									onChange={e => onToggleContentPersonalization(e.target.checked)}
									label="Allow content personalization"
								/>
								<ToggleSwitch
									disabled={local.personalization_storage === "denied" || (local.sale_opt_out === true && clientRegion.type !== "TCF")}
									checked={local.profiling === "granted"}
									onChange={e => onToggleProfiling(e.target.checked)}
									label="Allow profiling for personalization and service improvement"
								/>

								{isValidTCF && <>
									{displayTCFPurpose(1, false, "")}
								</>}
							</>}
						</div>
					</div>

					{/* Analytics */}
					<div className={styles.consentGroup}>
						<div className={styles.groupHeader}>
							<h3>Analytics</h3>
							{clientRegion.type === "" && <>
								<ToggleSwitch
									checked={local.analytics_storage === "granted"}
									onChange={e => onToggleAnalyticsGroup(e.target.checked)}
								/>
							</>}
						</div>
						<div className={styles.groupContent}>
							<p>
								These tools and mechanisms helps us understand how the site is used.
								We will use these information to improve our services and identify problems in the site.
							</p>

							{clientRegion.type !== "" && <>
								<ToggleSwitch
									checked={local.analytics_storage === "granted"}
									onChange={e => onToggleAnalytics(e.target.checked)}
									label="Allow Analytics"
								/>

								{clientRegion.type === "VCDPA" && <>
									<ToggleSwitch
										checked={local.sensitive_data_limit === true}
										onChange={e => onToggleSensitiveDataLimit(e.target.checked)}
										label="Limit the use of my sensitive personal data"
									/>
								</>}
							</>}
						</div>
					</div>

					{/* Advertising */}
					<div className={styles.consentGroup}>
						<div className={styles.groupHeader}>
							<h3>Marketing and Advertising</h3>
							{clientRegion.type === "" && <>
								<ToggleSwitch
									checked={local.ad_storage === "granted"}
									onChange={e => onToggleAdvertisingGroup(e.target.checked)}
								/>
							</>}
						</div>

						<div className={styles.groupContent}>
							<p>
								Used to show personalized or non-personalized ads from third party vendors.
							</p>

							{clientRegion.type !== "" && <>

							{/* Note: Needs to be explicit by California Law */}
							<ToggleSwitch
								checked={local.ad_storage === "granted"}
								onChange={e => onToggleAds(e.target.checked)}
								label="Allow non-personalized advertising cookies"
							/>
							<br />
							{/* CCPA - Do Not Sell / Share Personal Information */}

							{clientRegion.type !== "TCF" && <>
								<ToggleSwitch
									checked={local.sale_opt_out === true}
									onChange={e => onToggleSaleOptOut(e.target.checked)}
									label="Do Not Sell My Personal Info"
								/>
							</>}
							{/* Personalized Ads - within Site */}
							{isValidTCF
								? <>
									{displayTCFPurpose(3, false, "Allow personalized ads")}
								</>
								: <>
									{/* This disable rule: local.sale_opt_out === true, only applies to Non-TCF */}
									<ToggleSwitch
										disabled={local.sale_opt_out === true && clientRegion.type !== "TCF"}
										checked={local.tcf?.purposes?.[3] === true}
										onChange={e => onTogglePersonalizedAds(e.target.checked)}
										label="Allow personalized ads"
									/>
								</>
							}

							{/* Targeted Ads - usually Cross Site */}
							{isValidTCF
								? <>
									{displayTCFPurpose(4, false, "Allow targeted advertising")}
								</>
								: <>
									{/* This disable rule: local.sale_opt_out === true, only applies to Non-TCF; CPRA is opt-out so use different toggle */}
									{clientRegion.type === "CPRA"?
										<ToggleSwitch
											disabled={local.sale_opt_out === true && clientRegion.type !== "TCF"}
											checked={local.tcf?.purposes?.[4] !== true}
											onChange={e => onToggleTargetedAds(!e.target.checked)}
											label={"Do Not Share My Personal Information (Cross-context Behavioral Advertising)"}
										/>
									:
										<ToggleSwitch
											disabled={local.sale_opt_out === true && clientRegion.type !== "TCF"}
											checked={local.tcf?.purposes?.[4] === true}
											onChange={e => onToggleTargetedAds(e.target.checked)}
											label={"Allow targeted advertising"}
										/>
									}
								</>
							}
							{/* Invalid TCF or Non-TCF */}
							{/* This disable rule: (local.tcf?.purposes?.[3] === false || local.tcf?.purposes?.[4] === false || local.sale_opt_out === true), only applies to Non-TCF */}
							{(!isValidTCF || clientRegion.type !== "TCF") && <ToggleSwitch
								disabled={["CPRA", "VCDPA"].includes(clientRegion.type)
									? local.sale_opt_out === true
									: (local.tcf?.purposes?.[3] === false || local.tcf?.purposes?.[4] === false || local.sale_opt_out === true) && clientRegion.type !== "TCF"
								}
								checked={local.ad_user_data === "granted"}
								onChange={e => onToggleAdUserData(e.target.checked)}
								label="Allow sending hashed/anonymized user data to advertising partners"
							/>}

							{isValidTCF && <>
								{displayTCFPurpose(7, false, "")}
							</>}

							{isValidTCF && <>
								{/* Advanced TCF */}
								<br />
								<p
									className={styles.buttonText}
									onClick={() => setShowAdvanced(!showAdvanced)}
									onKeyDown={(e) => onKeyDownAccessibility(e, () => setShowAdvanced(true))}
									role="button"
									tabIndex={0}
								>
									{showAdvanced ? "Hide Vendor Settings" : "Show Vendor Settings"}
								</p>
								<br /><br />
								{showAdvanced && (
									<div>
										<h3>Vendors</h3>

										{config.tcfvendorlist.map(vendorobj => (
											displayVendor(vendorobj, true)
										))}
										{config.tcfnonvendorlist.map(vendorobj => (
											displayVendor(vendorobj, false)
										))}
									</div>
								)}
							</>}
							</>}
						</div>
						{isValidTCF && <>
							{CONSENTPURPOSELIST.length > 0 && <p>
								TCF Purposes are defined by the Interactive Advertising Bureau (IAB)
								Europe Transparency & Consent Framework (TCF) as a standardized set of
								data-processing purposes that ensure consistent disclosure, user choice,
								and interoperability between publishers, CMPs, and advertising vendors.
							</p>}
						</>}
					</div>
				</>
			}
		</div>

		{/* ACTION BUTTONS */}
		<div className={styles.actionList}>
			{!showCustomize &&
				<button
					className={styles.secondary} onClick={() => setShowCustomize(true)}
					name="customizeConsentButton"
					role="button"
					aria-label="Customize"
					aria-haspopup="dialog"
				>
					Customize
				</button>
			}
			<button
				onClick={onRejectAll}
				name="rejectAllConsentButton"
				role="button"
				aria-label="Reject All"
			>
				Reject All
			</button>
			{showCustomize &&
				<button
					onClick={onSave}
					name="savePreferencesConsentButton"
					role="button"
					aria-label="Save Preferences"
				>
					Save Preferences
				</button>
			}
			<button
				onClick={onAcceptAll}
				name="acceptAllConsentButton"
				role="button"
				aria-label="Accept All"
			>
				Accept All
			</button>
		</div>
	</div>
	</>)
}

export default ConsentBanner;
